import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmployeesPage, type EmployeesSearch } from '@/features/employees';

/** "Xodimlar boshqaruvi" (497:21046). Panels and filters are URL state: `?q=&page=&add=member|admin&member=:userId&tab=`. */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/employees')({
  validateSearch: z.object({
    q: z.string().optional().catch(undefined),
    page: z.coerce.number().int().min(1).optional().catch(undefined),
    add: z.enum(['member', 'admin']).optional().catch(undefined),
    member: z.string().optional().catch(undefined),
    tab: z.enum(['logs', 'info', 'permissions']).optional().catch(undefined),
  }),
  component: EmployeesRoute,
});

function EmployeesRoute() {
  const { me, tenant } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <EmployeesPage
      me={me}
      tenant={tenant}
      search={search}
      onSearchChange={(patch: Partial<EmployeesSearch>) =>
        void navigate({ search: (prev: EmployeesSearch) => ({ ...prev, ...patch }), replace: true })
      }
    />
  );
}
